<template>
  <div class="home">
    
    <InputHorasPersonal/>
  </div>
</template>

<script>
// @ is an alias to /src
import InputHorasPersonal from '@/components/InputHorasPersonal.vue'

export default {
  name: 'InputHorasPersonalView',
  components: {
    InputHorasPersonal,
        
  }
}
</script>
<style scoped>
.home{
  height: 100%;
}
.fc{
  height: 100%;
}
</style>
